import { IProduct } from '../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { Pool } from '../../../../../../../apis/pool.api';

export function P0003604BlowerMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.Blower_Controle,
    'blCResetProtectionMagnetique',
    1,
    null,
    productClass,
  );

  editValue(
    P00039DataRxTxIndex.Blower_Controle,
    'blCResetProtectionThermique',
    1,
    null,
    productClass,
  );

  return false;
}
